const exportXlsx = (pCsv: string, pNome: string) => {
  const arrayOfArrayCsv = pCsv.split('\n').map(row => row.split(';'));

  const wb = window.XLSX.utils.book_new();

  const newWs = window.XLSX.utils.aoa_to_sheet(arrayOfArrayCsv);

  XLSX.utils.book_append_sheet(wb, newWs, `COMMERCEPLUS`);

  XLSX.writeFile(wb, `${pNome}.xls`, { bookType: 'xls' });
};

export { exportXlsx };
